import classes from "../styles/TiltingPlane.module.css";
import { getClasses } from "../utils";

type TiltingPlaneType = {
  tilt: { x: number; y: number, z: number };
  perspective?: string;
  tiltBase?: { x: number; y: number, z: number };
  className?: string;
};
const TiltingPlane: React.FC<TiltingPlaneType> = (props) => {
  const perspective = props.perspective ?? "1000px";
  const rx = props.tilt.x * (props.tiltBase?.x ?? 1);
  const ry = props.tilt.y * (props.tiltBase?.y ?? 1);
  const rz = props.tilt.z * (props.tiltBase?.z ?? 1) * Math.sign(rx);
  // console.log(props.tilt.z);
  
  const sx = Math.round(props.tilt.x * -(props.tiltBase?.x ?? 3));
  const sy = Math.round(props.tilt.y * (props.tiltBase?.y ?? 3));
  const transform = `perspective(${perspective}) rotateX(${ry}deg) rotateY(${rx}deg) rotateZ(${rz}deg)`;
  const shadow =
    Math.max(Math.abs(props.tilt.x), Math.abs(props.tilt.y)) *
    (props.tiltBase?.x ?? 1) *
    2.5;
  const filter = `drop-shadow(${sx}px ${sy}px ${shadow}px rgba(0, 0, 0, 0.6))`;

  return (
    <div
      className={getClasses(classes, classes.plane, props.className)}
      style={{ transform, filter }}
    >
      {props.children}
    </div>
  );
};

export default TiltingPlane;
